export default __webpack_public_path__ + "static/media/wish_active.43f6acc9.svg";